import { jsxs as C, jsx as t } from "../../_virtual/jsx-runtime.mjs";
import * as o from "react";
import { reoCheckboxWrapper as M, reoCheckboxWrapperDisabled as W, sizeMap as z, ghost as R, reoCheckbox as D, reoCheckboxChecked as T, reoCheckboxInner as j, reoCheckboxInput as w, checkedIcon as B, reoCheckboxLabel as E } from "./css/ReoCheckbox.mjs";
import h from "../../depend/classnames/index.mjs";
import G from "./ReoCheckboxGroupContext.mjs";
import { defaultCheckboxProps as H } from "./const.mjs";
import { getValByDef as K } from "../../utils/getValByDef.mjs";
import L from "../ReoIcon/ReoIcon.mjs";
import { useTheme as O } from "../../hook/useTheme.mjs";
import { EThemeTemplate as P } from "../../common/type.mjs";
const V = (e) => {
  const s = O({ theme: e.theme, template: P.CHECKBOX }), c = o.useContext(G), [r, b] = o.useState(!1), l = o.useMemo(() => c.value ? c.value.includes(e.value) : e.checked ?? r, [r, e.checked, e.value, c]), n = o.useMemo(
    () => K(c.size ?? e.size, H.size),
    [e.size, c.size]
  ), a = o.useMemo(() => c.disabled ? !0 : e.disabled, [e.disabled, c.disabled]), m = o.useMemo(() => c.ghost ? !0 : e.ghost, [e.ghost, c.ghost]), x = o.useCallback((S) => {
    var k, i;
    if (a) {
      S.preventDefault();
      return;
    }
    c.onChange ? (k = c.onChange) == null || k.call(c, e.value, !l) : (e.checked, (i = e.onChange) == null || i.call(e, !l)), b((g) => !g);
  }, [a, l, e, c]), d = o.useCallback(() => null, []), u = o.useMemo(
    () => h(
      s,
      M,
      a ? W : null,
      z[n],
      m ? R : null,
      e.className,
      c.checkboxWrapClassName
    ),
    [a, m, e.className, n, c.checkboxWrapClassName, s]
  ), y = o.useMemo(
    () => ({
      "--color": c.color ?? e.color,
      "--hover-color": c.hoverColor ?? e.hoverColor,
      "--active-color": c.activeColor ?? e.activeColor,
      ...e.style,
      ...c.checkboxWrapStyle
    }),
    [
      e.activeColor,
      e.color,
      e.hoverColor,
      e.style,
      c.activeColor,
      c.color,
      c.hoverColor,
      c.checkboxWrapStyle
    ]
  ), N = o.useMemo(
    () => h(
      D,
      l ? T : null,
      c.checkboxClassName,
      e.checkboxClassName
    ),
    [l, e.checkboxClassName, c.checkboxClassName]
  ), f = o.useMemo(() => ({
    ...c.checkboxStyle,
    ...e.checkboxStyle
  }), [e.checkboxStyle, c.checkboxStyle]), v = o.useMemo(
    () => h(
      j,
      c.checkboxInnerClassName,
      e.checkboxInnerClassName
    ),
    [e.checkboxInnerClassName, c.checkboxInnerClassName]
  ), I = o.useMemo(
    () => ({
      ...c.checkboxInnerStyle,
      ...e.checkboxInnerStyle
    }),
    [e.checkboxInnerStyle, c.checkboxInnerStyle]
  );
  return /* @__PURE__ */ C(
    "div",
    {
      className: u,
      style: y,
      onClick: x,
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: N,
            style: f,
            children: [
              /* @__PURE__ */ t(
                "input",
                {
                  className: w,
                  type: "checkbox",
                  checked: l,
                  onChange: d
                }
              ),
              /* @__PURE__ */ t(
                "span",
                {
                  style: I,
                  className: v,
                  children: /* @__PURE__ */ t(
                    L,
                    {
                      width: "var(--icon-width)",
                      name: "icon-icon-check",
                      className: B[n]
                    }
                  )
                }
              )
            ]
          }
        ),
        e.children ? /* @__PURE__ */ t("span", { className: E, children: e.children }) : null
      ]
    }
  );
};
V.displayName = "ReoCheckbox";
export {
  V as default
};
//# sourceMappingURL=ReoCheckbox.mjs.map
